import React from 'react';
import type { EventDraftIssue } from './utils/VesselDraftUtils';
import { Box, Tooltip } from '../ui';
import { WarningAlertIcon, AlertIcon } from '../Icons';
import { PortCallEventType } from '../core/TimeData';

const PCEventTypeCaption = {
  [PortCallEventType.Arrival]: 'arrival',
  [PortCallEventType.Departure]: 'departure',
};

export const VesselDraftWarning = (props: {
  draftIssueSummary: EventDraftIssue;
  portCallEventType?: PortCallEventType.Arrival | PortCallEventType.Departure;
}) => {
  const { draftIssueSeverity, estimatedVesselDraft, portMaxDraft } =
    props.draftIssueSummary;
  return (
    <Tooltip
      content={
        <div>
          <strong>
            Vessel draft {draftIssueSeverity === 'warning' && 'almost '}exceeds
            port max draft{' '}
            {props.portCallEventType &&
              `at ${PCEventTypeCaption[props.portCallEventType]}`}
          </strong>
          <br />
          <br />
          <strong>Estimated vessel draft:</strong>{' '}
          {estimatedVesselDraft.toFixed(3)}
          <br />
          <strong>Port max draft:</strong> {portMaxDraft}
        </div>
      }
    >
      <Box
        ml={2}
        width="16px"
        height="16px"
        title={
          draftIssueSeverity === 'warning'
            ? 'Vessel max draft almost exceeds port draft'
            : 'Vessel max draft exceeds port draft'
        }
      >
        {draftIssueSeverity === 'warning' ? (
          <WarningAlertIcon />
        ) : (
          <AlertIcon />
        )}
      </Box>
    </Tooltip>
  );
};
